import React from 'react';
import PropTypes from 'prop-types';
import Style from './SearchInput.module.scss';

const SearchInput = ({ input, onInputChange }) => (
  <div className={input !== '' ? Style.inputContainer : Style.shortInputContainer}>
    <input
      type="text"
      className={Style.input}
      placeholder="Search"
      value={input}
      onChange={onInputChange}
    />
  </div>
);

SearchInput.propTypes = {
  input: PropTypes.string.isRequired,
  onInputChange: PropTypes.func.isRequired,
};
export default SearchInput;
